import util from '@bmp-vue/core/api/util'

const controller = 'ParametroCustomizacao'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByPortal: function (codigoPortal) {
    return util.Axios.GetAll(controller + '/GetAllByPortal', codigoPortal)
  },
  GetByIdentificador: function (codigoPortal) {
    return util.Axios.GetAll(controller + '/GetByIdentificador', codigoPortal)
  },
})
